import { render, staticRenderFns } from "./Frozen.vue?vue&type=template&id=e84842a6&scoped=true&"
import script from "./Frozen.vue?vue&type=script&lang=js&"
export * from "./Frozen.vue?vue&type=script&lang=js&"
import style0 from "./Frozen.vue?vue&type=style&index=0&id=e84842a6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e84842a6",
  null
  
)

export default component.exports